'use client';
var IDENT_INPUT_LABEL = "InputLabel";
var defaultProps = {
    labelElement: "label",
    size: "sm1",
    color: "neutral.300"
};

export { IDENT_INPUT_LABEL, defaultProps };
